module.exports = __webpack_public_path__ + "static/media/retail_store_840x520.bed6ebd9.jpg";